module.exports = __webpack_public_path__ + "static/media/realestate.e7e81d44.png";